import { render, staticRenderFns } from "./card-select-user.vue?vue&type=template&id=888e6e12&"
import script from "./card-select-user.vue?vue&type=script&lang=js&"
export * from "./card-select-user.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports